// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { Bill } from './bill';
import { TimeCategory } from './time-category';
import { TimeEntry } from './time-entry';
import { TimeEntryType } from './time-entry-type';

/// <code-import> Place custom imports between <code-import> tags
import { core } from 'breeze-client';
export type BillDetailsFlags = 'Deleted'; // Example 'Foo' | 'Bar'
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BillDetail extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  /* Unique id for proper data management in AG Grid due to temporary IDs when creating nominal bill details */
  uuid = core.getUuid();

  hasFlag(flag: BillDetailsFlags): boolean {
    const flags = this.parseFlags();
    return flags.some((f) => f === flag);
  }

  setFlag(flag: BillDetailsFlags): void {
    if (this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.push(flag);
    this.flags = flags.join(', ') || '0';
  }

  clearFlag(flag: BillDetailsFlags): void {
    if (!this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.splice(flags.indexOf(flag), 1);
    this.flags = flags.join(', ') || '0';
  }

  private parseFlags(): string[] {
    const flags = this.flags || '0'; // Could be numeric zero
    if (flags === '0') {
      return [];
    }
    return flags.split(',').map((flag) => flag.trim());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  parentBillDetailId?: number;
  billId!: number;
  billMemo?: string;
  billedRate?: number;
  billedTotal!: number;
  billedUnits?: number;
  createdAt!: Date;
  createdBy?: string;
  entryDateTime!: Date;
  flags!: string;
  hasTax!: boolean;
  billTax?: number;
  origBilledTotal?: number;
  timeCategory1Id?: number;
  timeCategory2Id?: number;
  timeEntryId?: number;
  timeEntryTypeId!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  userId!: number;
  writeOffTotal?: number;
  bill!: Bill;
  timeCategory1!: TimeCategory;
  timeCategory2!: TimeCategory;
  timeEntry!: TimeEntry;
  timeEntryType!: TimeEntryType;
}

